import { DOCUMENT } from '@angular/common';
import { Directive, Inject, Input, OnDestroy, OnInit } from '@angular/core';

import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

@Directive({
    selector: '[btlToggleBodyClass]',
})
export class ToggleBodyClassDirective implements OnInit, OnDestroy {
    @Input() className: string = 'fullscreen-filters'; // How to reach constants properly
    @Input() toggleCondition: boolean = false;
    private $toggleObs: Observable<boolean> = of(this.toggleCondition);

    constructor(@Inject(DOCUMENT) private document: Document) {}

    ngOnInit() {
        this.$toggleObs
            .pipe(
                tap((val) => {
                    this.document.body.classList.toggle(this.className);
                }),
            )
            .subscribe();
    }

    ngOnDestroy() {
        this.$toggleObs = null;
        this.document.body.classList.remove(this.className);
    }
}
